<p-dialog
  modal="true"
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <p *ngIf="checkingRegistrations.busy || deleting.busy"><wl-busy [show]="true"></wl-busy></p>
  <div
    class="alert alert-danger"
    *ngIf="!checkingRegistrations.busy && !checkingRegistrations.success && checkingRegistrations.message?.length"
  >
    {{ checkingRegistrations.message }}
  </div>
  <div class="alert alert-danger" *ngIf="!deleting.busy && !deleting.success && deleting.message?.length">{{ deleting.message }}</div>

  <div [hidden]="checkingRegistrations.busy || deleting.busy || !_checkedRegistrations">
    <p [hidden]="!_hasRegistrations">{{ 'events.shared.delete-event.has-registrations-message' | translate }}</p>
    <div class="alert alert-warning" [hidden]="_hasRegistrations">
      <p>
        <strong>{{ 'common.action-cannot-be-undone-warning' | translate }}</strong>
      </p>
      <p>{{ 'events.shared.delete-event.delete-warning-message' | translate }}</p>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <wl-busy *ngIf="deleting.busy" [show]="deleting.busy"></wl-busy>
    <input type="checkbox" [(ngModel)]="_deleteSafetyOff" [disabled]="checkingRegistrations.busy || deleting.busy || _hasRegistrations" />
    <button
      pButton
      type="button"
      class="btn btn-danger"
      icon="pi pi-trash"
      [label]="'events.shared.delete-event.yes-button-label' | translate | titlecase"
      (click)="handleDeleteClick()"
      [disabled]="checkingRegistrations.busy || deleting.busy || _hasRegistrations || !_deleteSafetyOff"
    ></button>
    <cancel-button
      [label]="'events.shared.delete-event.cancel-button-label' | translate | titlecase"
      [disabled]="checkingRegistrations.busy || deleting.busy"
      (onClick)="handleCancelClick()"
    >
    </cancel-button>
  </ng-template>
</p-dialog>
